<template>
<div>
  <el-button type="success"
    @click="$modal.show('educational-dialog');">
    자동 입력
  </el-button>

  <div class="education-option">
    <modal name="educational-dialog"
      :adaptive="true"
      :scrollable="true"
      height="auto">
      <div class="v--modal-close-top">
        <el-button @click="$modal.hide('educational-dialog');"
          icon="el-icon-close"
          type="text"></el-button>
      </div>
      <div class="title">학력 자동 입력</div>
      <p>생년월일과 재적날짜를 바탕으로 입학·졸업년을 자동 계산합니다.</p>
      <p>&nbsp;</p>
      <div class="edit-form">
        <div class="edit-form-item">
          <div class="item-name">생년월일</div>
          <div class="item-body flex align-items-center">
            <el-input class="input-xs"
              placeholder="2000"
              title="년"
              v-model="birthYear"
              min="1890"
              type="number"></el-input><span>년</span>
            <el-input class="input-xs input-2-digit"
              placeholder="00"
              title="월"
              v-model="birthMonth"
              min="1"
              max="12"
              type="number"></el-input><span>월</span>
            <el-input class="input-xs input-2-digit"
              placeholder="00"
              title="일"
              v-model="birthDay"
              min="1"
              max="31"
              type="number"></el-input><span>일</span>
          </div>
          <div v-if="errorMessage"
            class="error">{{ errorMessage }}</div>
          <div class="item-name">최종학력</div>
          <div class="item-body">
            <el-select v-model="options.lastEducationalBackground"
              placeholder="Select">
              <el-option v-for="item in lastEducationalBackgroundOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
        </div>

        <div class="edu-auto-school">
          <div class="edit-form-item">
            <div class="item-name">
              중학교
              <el-checkbox v-model="options.periods.juniorHighSchool.display"
                class="edu-auto-checkbox">이력서에 입력</el-checkbox>
            </div>
            <div class="item-body">
              <el-input v-model="options.periods.juniorHighSchool.name"
                v-show="options.periods.juniorHighSchool.display"
                class="school-name"
                :placeholder="options.periods.juniorHighSchool.display ? options.periods.juniorHighSchool.defaultName:'입력할수없습니다'"></el-input>
              <el-input v-model="options.periods.juniorHighSchool.period"
                class="period input-2-digit"
                controls-position="right"
                type="number"
                :min="0"></el-input><span>재학기간</span>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">
              <div v-if="options.lastEducationalBackground === 'instituteOfTechnologyCollege'">전문고등학교</div>
              <div v-else>고등학교
                <el-checkbox v-model="options.periods.highSchool.display"
                  class="edu-auto-checkbox">이력서에 입력</el-checkbox>
              </div>
            </div>
            <div class="item-body">
              <el-input class="school-name"
                :placeholder="options.periods.highSchool.display ? options.periods.highSchool.defaultName:'입력할수없습니다'"
                v-model="options.periods.highSchool.name"
                v-show="options.periods.highSchool.display"></el-input>
              <el-input v-model="options.periods.highSchool.period"
                class="period input-2-digit"
                type="number"
                controls-position="right"
                :min="0"></el-input><span>재학기간</span>
              <span v-if="options.periods.highSchool.display">
              <el-select v-model="options.periods.highSchool.graduateLabel"
                         class="input-sm"
                         placeholder="Select">
                <el-option v-for="item in graduateLabels"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
              </span>
            </div>
          </div>
          <div class="edit-form-item"
            v-if="!(options.lastEducationalBackground in {'highSchool':1, 'instituteOfTechnologyCollege':1})">
            <div class="item-name">고등학교 졸업 후(예비학교, 재수생 등)</div>
            <div class="item-body">
              <el-input class="school-name"
                disable
                :placeholder="options.periods.afterHighSchool.defaultName"
                v-model="options.periods.afterHighSchool.name"
                v-show="false"></el-input>
              <el-input v-model="options.periods.afterHighSchool.period"
                type="number"
                class="period input-2-digit"
                controls-position="right"
                :min="0"></el-input><span>재학기간</span>
            </div>
          </div>
          <div class="edit-form-item"
            v-if="options.lastEducationalBackground in {'university':0, 'master':0, 'docter':0}">
            <div class="item-name">대학</div>
            <div class="item-body">
              <el-input class="school-name"
                :placeholder="options.periods.university.defaultName"
                v-model="options.periods.university.name"></el-input>
              <el-input v-model="options.periods.university.period"
                type="number"
                class="period input-2-digit"
                controls-position="right"
                :min="0"></el-input><span>재학기간</span>
              <el-select v-model="options.periods.university.graduateLabel"
                class="input-sm"
                placeholder="Select">
                <el-option v-for="item in graduateLabels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="edit-form-item"
            v-if="options.lastEducationalBackground == 'juniorCollege'">
            <div class="item-name">단기대학</div>
            <div class="item-body">
              <el-input class="school-name"
                v-model="options.periods.juniorCollege.name"
                :placeholder="options.periods.juniorCollege.defaultName"
                :disabled="options.lastEducationalBackground != 'juniorCollege'"></el-input>
              <el-input v-model="options.periods.juniorCollege.period"
                type="number"
                class="period input-2-digit"
                controls-position="right"
                :min="0"></el-input><span>재학기간</span>
              <el-select v-model="options.periods.juniorCollege.graduateLabel"
                class="input-sm"
                placeholder="Select">
                <el-option v-for="item in graduateLabels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="edit-form-item"
            v-if="options.lastEducationalBackground == 'specialSchool'">
            <div class="item-name">전문대학</div>
            <div class="item-body">
              <el-input v-model="options.periods.specialSchool.name"
                class="school-name"
                :placeholder="options.periods.specialSchool.defaultName"
                :disabled="options.lastEducationalBackground != 'specialSchool'"></el-input>
              <el-input class="period input-2-digit"
                type="number"
                v-model="options.periods.specialSchool.period"
                controls-position="right"
                :min="0"></el-input><span>재학기간</span>
              <el-select v-model="options.periods.specialSchool.graduateLabel"
                class="input-sm"
                placeholder="Select">
                <el-option v-for="item in graduateLabels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="edit-form-item"
            v-if="options.lastEducationalBackground in {'docter':1, 'master':1}">
            <div class="item-name">대학원（석사）</div>
            <div class="item-body">
              <el-input class="school-name"
                :placeholder="options.periods.master.defaultName"
                v-model="options.periods.master.name"></el-input>
              <el-input class="period input-2-digit"
                type="number"
                v-model="options.periods.master.period"
                controls-position="right"
                :min="0"></el-input><span>재학기간</span>
              <el-select v-model="options.periods.master.graduateLabel"
                class="input-sm"
                placeholder="Select">
                <el-option v-for="item in graduateLabels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="edit-form-item"
            v-if="options.lastEducationalBackground in {'docter':1}">
            <div class="item-name">대학원（박사）</div>
            <div class="item-body">
              <el-input class="school-name"
                :placeholder="options.periods.docter.defaultName"
                v-model="options.periods.docter.name"></el-input>
              <el-input class="period input-2-digit"
                type="number"
                v-model="options.periods.docter.period"
                controls-position="right"
                :min="0"></el-input><span>재학기간</span>
              <el-select v-model="options.periods.docter.graduateLabel"
                class="input-sm"
                placeholder="Select">
                <el-option v-for="item in graduateLabels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <el-button type="primary"
          @click="autoComplete">이내용 추가</el-button>
        <el-button @click="$modal.hide('educational-dialog');">닫기</el-button>
        <div>※현재 입력하고 있는 학력은 모두 덮어씁니다.</div>
      </div>
      <div class="text-right">
        <br/>
        <br/>
      </div>
    </modal>
  </div>
</div>
</template>

<script>
import _ from '@/assets/lib/my-lodash'
export default {
  props: {
    year: {
      type: [Number, String]
    },
    month: {
      type: [Number, String]
    },
    day: {
      type: [Number, String]
    }
  },
  data: function () {
    return {
      birthYear: 1985,
      birthMonth: 1,
      birthDay: 1,
      errorMessage: '',
      resetDialogVisible: false,
      educationalBackground: {},
      graduateLabels: [
        {
          value: '졸업',
          label: '졸업'
        },
        {
          value: '재학중',
          label: '재학중'
        },
        {
          value: '졸업예정',
          label: '졸업예정'
        },
        {
          value: '수료',
          label: '수료'
        },
        {
          value: '중퇴',
          label: '중퇴'
        }
      ],
      lastEducationalBackgroundOptions: [
        {
          value: 'highSchool',
          label: '고교'
        },
        {
          value: 'instituteOfTechnologyCollege',
          label: '전문고교'
        },
        {
          value: 'specialSchool',
          label: '전문학교'
        },
        {
          value: 'juniorCollege',
          label: '전문대학'
        },
        {
          value: 'university',
          label: '대학'
        },
        {
          value: 'master',
          label: '대학원(석사)'
        },
        {
          value: 'docter',
          label: '대학원(박사)'
        }
      ],
      options: {
        lastEducationalBackground: 'university',
        periods: {
          // 中学
          juniorHighSchool: {
            name: '',
            display: false,
            defaultName: '○○시립○○중학교',
            period: 3,
            displayEnter: false
          },
          // 고교
          highSchool: {
            name: '',
            display: true,
            defaultName: '○○시 ○○고등학교 ○○학과',
            period: 3,
            graduateLabel: '졸업'
          },
          afterHighSchool: {
            name: '',
            defaultName: '고등학교 졸업 후(입력할수없습니다)',
            period: 0
          },
          // 大学
          university: {
            name: '',
            defaultName: '〇〇대학 〇〇학부 〇〇학과',
            period: 4,
            graduateLabel: '졸업'
          },
          // 전문대학
          juniorCollege: {
            name: '',
            defaultName: '〇〇전문대학 〇〇학부 〇〇학과',
            period: 2,
            graduateLabel: '졸업'
          },
          // 専門
          specialSchool: {
            name: '',
            defaultName: '〇〇전문학교 ◯◯과 ◯◯코스',
            period: 2,
            graduateLabel: '졸업'
          },
          master: {
            name: '',
            defaultName: '◯◯대학 ◯◯대학원　◯◯학연구과 ◯◯학전공 석사과정',
            period: 2,
            graduateLabel: '수료'
          },
          docter: {
            name: '',
            defaultName: '◯◯대학 ◯◯대학원　◯◯학문 연구과 ◯◯학전공 박사과정',
            period: 2,
            graduateLabel: '수료'
          }
        }
      }
    }
  },
  computed: {},
  methods: {
    autoComplete: function () {
      this.errorMessage = ''
      if (!this.birthYear || !this.birthMonth || !this.birthDay) {
        this.errorMessage = '생년월일을 입력 해주세요'
        return
      }
      this.createEducationalBackground(this.options)
      this.$emit('create-educational-background', this.educationalBackground.getRirekishoList())
      this.$modal.hide('educational-dialog')
    },
    createEducationalBackground: function () {
      const birthYear = Number(this.birthYear)
      const birthMonth = Number(this.birthMonth)
      const birthDay = Number(this.birthDay)
      const BackgroundItem = function (ItemOptions) {
        this.enable = ItemOptions.enable || false
        this.display = ItemOptions.display || false
        this.displayEnter = ItemOptions.hasOwnProperty('displayEnter') ? ItemOptions.displayEnter : true
        this.displayGraduate = ItemOptions.hasOwnProperty('displayGraduate') ? ItemOptions.displayGraduate : true
        this.period = Number(ItemOptions.period) || 0
        this.name = ItemOptions.name || ''
        this.enterMonth = ItemOptions.enterMonth || 3
        this.enterLabel = ItemOptions.enterLabel || '입학'
        this.graduateMonth = ItemOptions.graduateMonth || 2
        this.graduateLabel = ItemOptions.graduateLabel || '졸업'
        this.order = ItemOptions.order || 0
      }
      const educationalBackground = {}
      const getGraduateElementaryYear = () => {
        // 中学入学年度を計算（早生まれは１年遅れる）
        if (birthMonth < 4 || (birthMonth === 4 && birthDay === 1)) {
          return birthYear + 12
        } else {
          return birthYear + 13
        }
      }
      let order = 1
      const orderStep = 100
      educationalBackground.defaultOptions = {
        startYear: getGraduateElementaryYear(),
        lastEducationalBackground: 'university',
        higherEducations: ['specialSchool', 'juniorCollege', 'university', 'master', 'docter'],
        periods: {
          // 中学
          juniorHighSchool: {
            enable: true,
            display: true,
            period: 3,
            name: '○○중학교',
            displayEnter: false,
            order: order++ * orderStep
          },
          afterJuniorHighSchool: {
            name: '고교 재수생',
            order: order++ * orderStep
          },
          // 고교
          highSchool: {
            enable: true,
            display: true,
            period: 3,
            name: '○○고교',
            order: order++ * orderStep
          },
          afterHighSchool: {
            enable: true,
            name: '재수',
            order: order++ * orderStep
          },
          // 전문대학
          juniorCollege: {
            display: true,
            period: 2,
            name: '○○전문대학',
            order: order++ * orderStep
          },
          // 専門
          specialSchool: {
            display: true,
            period: 2,
            name: '○○전문학교',
            order: order++ * orderStep
          },
          // 대학
          university: {
            display: true,
            period: 4,
            name: '사립〇〇대학 〇〇학과 〇〇학부',
            order: order++ * orderStep
          },
          master: {
            display: true,
            period: 2,
            name: '◯◯대학 대학원　◯◯학연구과 ◯학전공 석사과정',
            graduateLabel: '수료',
            order: order++ * orderStep
          },
          docter: {
            display: true,
            period: 2,
            name: '◯◯대학 대학원 ◯◯학연구과 ◯학전공 박사과정',
            graduateLabel: '수료',
            order: order++ * orderStep
          }
        }
      }
      educationalBackground.options = _.defaultsDeep(this.options, educationalBackground.defaultOptions)
      educationalBackground.options.startYear = getGraduateElementaryYear()
      educationalBackground.setHigherEducationBackground = function (lastEducationalBackgroundKey) {
        // console.log(lastEducationalBackgroundKey)
        // 指定した高等教育(lastEducationalBackground)のみ有効にする
        for (let key in this.options.higherEducations) {
          let he = this.options.higherEducations[key]
          if (!this.options.periods[he]) continue
          this.options.periods[he]['enable'] = false
        }
        this.options.periods[lastEducationalBackgroundKey]['enable'] = true

        if (lastEducationalBackgroundKey === 'master') {
          this.options.periods['university']['enable'] = true
        }
        if (lastEducationalBackgroundKey === 'docter') {
          this.options.periods['university']['enable'] = true
          this.options.periods['master']['enable'] = true
        }
      }
      educationalBackground.getRirekishoList = function () {
        const options = this.options
        let lastEducationalBackground = options.lastEducationalBackground || 'university'
        // 高専は高校を上書きして使うため高校に戻す
        if (lastEducationalBackground === 'instituteOfTechnologyCollege') {
          lastEducationalBackground = 'highSchool'
        }
        this.setHigherEducationBackground(lastEducationalBackground)
        const rirekishoList = []
        let year = options.startYear
        const orderedPeriods = _.orderBy(options.periods, ['order'], ['asc'])
        for (let key in orderedPeriods) {
          let item = new BackgroundItem(orderedPeriods[key])
          if (!item.enable || !item.period === 0) {
            continue
          }
          if (item.display && item.displayEnter) {
            // console.log(item)
            rirekishoList.push({
              year: year,
              month: item.enterMonth,
              desc: item.name + ' ' + item.enterLabel
            })
          }
          year = year + item.period
          if (item.display && item.displayGraduate) {
            rirekishoList.push({
              year: year,
              month: item.graduateMonth,
              desc: item.name + ' ' + item.graduateLabel
            })
          }
          if (lastEducationalBackground === key) {
            break
          }
        }
        return rirekishoList
      }
      this.educationalBackground = educationalBackground
    }
  },
  watch: {
    'year': function () {
      this.birthYear = this.year
    },
    'month': function () {
      this.birthMonth = this.month
    },
    'day': function () {
      this.birthDay = this.day
    },
    'birthYear': function () {
      this.$eventHub.$emit('birth-year-changed', this.birthYear)
    },
    'birthMonth': function () {
      this.$eventHub.$emit('birth-month-changed', this.birthMonth)
    },
    'birthDay': function () {
      this.$eventHub.$emit('birth-day-changed', this.birthDay)
    },
    'options.lastEducationalBackground': function (newVal, oldVal) {
      if (newVal === 'instituteOfTechnologyCollege') {
        this.options.periods.highSchool.period = 5
        this.options.periods.highSchool.defaultName = '시〇〇공업고등전문학교　〇〇과'
      } else {
        this.options.periods.highSchool.period = 3
        this.options.periods.highSchool.defaultName = '시 OO고등학교 문과'
      }
    }
  },
  mounted: function () {
    this.birthYear = this.year
    this.birthMonth = this.month
    this.birthDay = this.day
  }
}
</script>
